import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Field Operations Module Service Stores
 * Updated to match backend api-types
 */
export const fieldStores: ServiceStoreConfig[] = [
  {
    name: "crane-lift-operations",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.craneLiftOperationsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalOperations = entities.length;
          const completed = entities.filter(
            (op: Record<string, unknown>) => op.status === "completed"
          ).length;
          const inProgress = entities.filter(
            (op: Record<string, unknown>) => op.status === "in_progress" || op.status === "active"
          ).length;
          const thisWeek = entities.filter((op: Record<string, unknown>) => {
            const liftDate = new Date(op.liftDate as string);
            const now = new Date();
            const weekAgo = new Date();
            weekAgo.setDate(now.getDate() - 7);
            return liftDate > weekAgo;
          }).length;

          return [
            {
              title: "Total Operations",
              value: () => totalOperations.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Completed",
              value: () => completed.toString(),
              valueColor: "success.main",
            },
            {
              title: "In Progress",
              value: () => inProgress.toString(),
              valueColor: "warning.main",
            },
            {
              title: "This Week",
              value: () => thisWeek.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "crane-lift-plans",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.craneLiftPlansStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalPlans = entities.length;
          const approved = entities.filter(
            (plan: Record<string, unknown>) => plan.status === "approved"
          ).length;
          const pending = entities.filter(
            (plan: Record<string, unknown>) => plan.status === "pending" || plan.status === "draft"
          ).length;
          const avgLiftWeight = entities.length > 0
            ? entities.reduce((sum: number, plan: Record<string, unknown>) => {
                return sum + ((plan.estimatedWeightLbs as number) || 0);
              }, 0) / entities.length
            : 0;

          return [
            {
              title: "Total Plans",
              value: () => totalPlans.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Approved",
              value: () => approved.toString(),
              valueColor: "success.main",
            },
            {
              title: "Pending",
              value: () => pending.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Avg Lift Weight",
              value: () => `${((avgLiftWeight as number) / 1000).toFixed(1)}K lbs`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
];
